import { render, staticRenderFns } from "./WorkHourDetailsModal.vue?vue&type=template&id=067549d0&scoped=true"
import script from "./WorkHourDetailsModal.vue?vue&type=script&lang=js"
export * from "./WorkHourDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./WorkHourDetailsModal.vue?vue&type=style&index=0&id=067549d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067549d0",
  null
  
)

export default component.exports